module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_9005.a2a26eac.png";